import { put, call, takeLatest } from 'redux-saga/effects';

import * as actions from '../actions';
import { ACCOUNT } from '../constants';
import { registerAccount } from '../api';

export default function* watchAccount() {
    yield takeLatest(ACCOUNT.REGISTER_ACCOUNT, registerAccountSaga)
}

export function* registerAccountSaga(action) {
    try {
        yield put(actions.registerAccountLoad());
        yield call(registerAccount, action.accountData);
        yield put(actions.registerAccountSuccess());
    } catch (error) {
        console.error(error);
        yield put(actions.registerAccountFail());
    }

}

